import { jsx as _jsx } from "react/jsx-runtime";
import { Helmet } from 'react-helmet';
import { AniEventTypes } from '@constants/ani';
var AniScript = function (props) {
    var data = props.data;
    var value = data.value;
    return (_jsx(Helmet, { children: _jsx("script", { type: "text/javascript", id: "ani-init", children: "\n          (function (a, n, i, s, d, k) {\n            a[s] = a[s] || []; d = n.createElement(i); d.async = 1;\n            d.src = 'https://cdn.ciceksepeti.com/ani/ani-v8.js';\n            k = n.getElementsByTagName(i)[0]; k.parentNode.insertBefore(d, k);\n          })(window, document, 'script', 'ani');\n          ani.push([\"".concat(AniEventTypes.API_KEY, "\", \"").concat(value, "\"]);\n        ") }) }));
};
export default AniScript;
